<template>
  <aside
    id="values-summary"
    :class="{
      'c-wallet-values-summary--fixed': summaryFixed,
    }"
    class="c-wallet-values-summary"
    :route="{ name: 'carteira' }"
  >
    <div class="c-wallet-values-summary__wrapper">
      <div class="c-wallet-values-summary__header">
        <Tooltip
          :showTooltip="showTooltipAddMoneyPixFlag"
          :positionSide="tooltipData.positionSide"
          :position="tooltipData.position"
          :title="tooltipData.title"
          :description="tooltipData.description"
        />
        <p><strong>Saldo disponível para uso</strong></p>
        <p>
          <strong class="has-text-support is-size-4 is-size-2-desktop">
            {{ walletSummary.balance | currency }}
          </strong>
          <br />
          <small>
            <span class="label-formatted-styles"
              >Disponível para resgate até 12 meses<br />
              após a data do casamento<br
            /></span>
            <span class="time-formatted-styles"
              >Atualizado hoje às
              {{ getTime(walletSummary.last_transaction_at) }}</span
            >
          </small>
        </p>
        <BaseCardColor v-if="bonusReceived.bonus_amount">
          <div
            @click="userValidateToRedirect('shopping')"
            class="c-base-card-color__content"
          >
            <div class="c-base-card-color__description has-text-left">
              <small>Bônus exclusivo Shopping Casar.com</small>
            </div>
            <div
              class="c-base-card-color__money has-text-support has-text-right"
            >
              <span class="has-text-bold">
                {{ bonusReceived.bonus_amount | currency }}
              </span>
              <button class="c-base-card-color__arrow-button" type="button">
                <span class="icon">
                  <base-icon
                    width="1.4em"
                    height="1.4em"
                    name="painel/chevron-left-icon"
                  />
                </span>
              </button>
            </div>
          </div>
          <div
            class="has-text-left"
            v-if="bonusReceived.expirable_bonus_next_expiration"
          >
            <small
              ><b>{{ bonusReceived.expirable_bonus_amount | currency }}</b> com
              vencimento em
              {{
                bonusReceived.expirable_bonus_next_expiration | dateWithoutHours
              }}</small
            >
          </div>
        </BaseCardColor>
      </div>

      <div
        v-if="walletSummary?.loading || walletSummary?.pending"
        class="has-text-centered"
      >
        <base-reload :isReload="false" :dark="true" label="" />
      </div>
      <div class="c-wallet-values-summary__body" v-else>
        <base-accordion-wallet
          :value="walletSummary.total_gain | currency"
          label="Total recebido"
          color="has-text-support"
          prefix="+"
        >
          <p class="margin-bottom">
            Valor de presente já liberado<br />
            <strong>+ {{ walletSummary.balance_gift | currency }}</strong>
          </p>
          <p>
            Cashback gerado<br />
            <strong> + {{ walletSummary.total_cashback | currency }} </strong>
            <small class="has-text-support">Retorno médio de 4%</small>
          </p>
        </base-accordion-wallet>
        <base-accordion-wallet
          :value="walletSummary.total_used | currency"
          label="Total utilizado"
          color="has-text-error"
          prefix="-"
        >
          <p class="margin-bottom">
            Transferências realizadas<br />
            <strong>- {{ walletSummary.balance_withdraw | currency }}</strong>
          </p>
          <p>
            Compras no Shopping Casar.com<br />
            <strong>- {{ walletSummary.balance_shopping | currency }}</strong>
          </p>
        </base-accordion-wallet>
        <base-accordion-wallet
          v-if="!amountToReceive.loading && !cashbackAmountToReceive.loading"
          :value="totalPendingAmount | currency"
          label="Créditos aguardando liberação"
        >
          <p class="margin-bottom">
            Presentes aguardando liberação
            <span
              class="icon tooltip is-tooltip-multiline"
              data-tooltip="Os valores dos presentes ficam disponíveis em seu saldo em 3 dias."
            >
              <base-icon
                width="1.3em"
                height="1.3em"
                name="painel/help-icon"
              /> </span
            ><br />
            <strong>+ {{ amountToReceive | currency }}</strong>
          </p>
          <p>
            Cashback aguardando liberação
            <span
              class="icon tooltip is-tooltip-multiline"
              data-tooltip="Os valores dos cashbacks são liberados em seu saldo em 10 dias."
            >
              <base-icon
                width="1.3em"
                height="1.3em"
                name="painel/help-icon"
              /> </span
            ><br />
            <strong>+ {{ cashbackAmountToReceive | currency }}</strong>
          </p>
        </base-accordion-wallet>
      </div>

      <div class="c-wallet-values-summary__footer">
        <button
          @click="goToUseBalance"
          :disabled="!walletSummary.owner_cpf"
          type="button"
          class="button is-fullwidth is-flex margin-bottom is-primary is-big"
        >
          <base-icon
            style="margin-right: 0.5em"
            width="24px"
            height="24px"
            name="painel/money-icon"
          />
          Utilizar saldo
        </button>

        <div class="button-withdraw-pix">
          <div class="button-withdraw-pix__tooltip">
            <Tooltip
              :showTooltip="showT"
              :positionSide="tooltipData.positionSide"
              :position="tooltipData.position"
              :title="tooltipData.title"
              :description="tooltipData.description"
            />
          </div>
          <button
            @click="goToWithdraw"
            :disabled="!walletSummary.owner_cpf"
            type="button"
            class="button is-flex is-fullwidth margin-bottom is-outlined is-black is-big button__transfer"
            style="font-size: 15px"
          >
            <base-icon
              style="margin-right: 0.5em"
              width="24px"
              height="24px"
              name="painel/pix-icon-btn"
            />
            Cadastrar conta de recebimento
          </button>
        </div>

        <router-link
          :to="{ name: 'carteira-extrato' }"
          class="button is-flex margin-bottom is-outlined is-black is-big is-hidden-tablet"
        >
          Ver extrato de transações
        </router-link>
      </div>
    </div>

    <TheModalAccountIsPending ref="modalAccountIsPending" />
    <BaseModalError
      ref="modalErrorBalance"
      title="Erro ao carregar saldo"
      icon="paypal-with-error"
      :message="`<strong>Infelizmente não será possível solicitar<br>a transferência neste momento!</strong>`"
    />
  </aside>
</template>

<script>
import TheModalAccountIsPending from '@/components/Wallet/TheModalAccountIsPending.vue'
import BaseAccordionWallet from '@/components/Wallet/BaseAccordionWallet.vue'
import BaseCardColor from '@/components/Wallet/BaseCardColor.vue'
import BaseModalError from '@/components/BaseModalError.vue'

import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'
import Tooltip from '@/components/BaseTooltip.vue'

import currency from 'currency.js'

export default {
  mixins: [verifyDataUserMixin],

  components: {
    TheModalAccountIsPending,
    BaseAccordionWallet,
    BaseModalError,
    BaseCardColor,

    Tooltip,
  },
  data() {
    return {
      summaryFixed: null,
      tooltipData: {},
      showT: false,
      showTooltipAddMoneyPixFlag: false,
    }
  },
  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    amountToReceive() {
      return this.$store.state.wallet.amountToReceive
    },

    cashbackAmountToReceive() {
      return this.$store.state.wallet.cashbackAmountToReceive
    },

    bonusReceived() {
      return this.$store.state.wallet.bonusReceived.bonus_amount > 0
        ? this.$store.state.wallet.bonusReceived
        : false
    },

    totalPendingAmount() {
      if (
        !this.amountToReceive.loading &&
        !this.cashbackAmountToReceive.loading
      )
        return this.sum(this.amountToReceive, this.cashbackAmountToReceive)
      return 0
    },
  },

  created() {
    // show tooltip
    this.$store.state.wallet.pix_amount_credited > 0
      ? this.showTooltipAddMoneyPix(
          this.$store.state.wallet.pix_amount_credited
        )
      : ''
  },

  mounted() {
    window.addEventListener('scroll', this.setSummaryFixed)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.setSummaryFixed)
  },

  methods: {
    getTime(time) {
      return time.substring(10, 16)
    },
    goToWithdraw() {
      this.$ga.event('carteira', 'click', 'carteira-cadastrar-conta')
      this.$router.push({ name: 'carteira-saque' })
    },
    goToUseBalance() {
      this.$ga.event('carteira', 'click', 'carteira-utilizar-saldo')
      this.$router.push({ name: 'utilizar-saldo' })
    },

    sum(a, b) {
      return parseFloat(a) + parseFloat(b)
    },

    showTooltipAddMoneyPix(amount) {
      if (!this.showT) {
        this.$store.dispatch('setCreditedPixAmount', 0)
        let amountFormated = currency(amount, {
          separator: '.',
          decimal: ',',
          hour12: false,
        }).format()

        this.tooltipData = {
          positionSide: 'bottom',
          position: 'middle',
          title: '',
          description:
            '<b>Recebemos o seu Pix</b> no valor de <b>R$' +
            amountFormated +
            '</b>.',
        }
        this.showTooltipAddMoneyPixFlag = true
      }
    },

    setSummaryFixed() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop

      if (currentScrollPosition > 460) {
        if (navigator.userAgent.indexOf('MSIE') > -1) {
          this.summaryFixed = true
        }
      } else {
        this.summaryFixed = false
      }
    },

    // Function from verifyDataUserMixin
    userValidateToRedirect(params) {
      if (this.verifyDataUser()) {
        this.goTo(params)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>

<style lang="scss">
.label-formatted-styles {
  display: block;
  margin-top: 7px;
}

.time-formatted-styles {
  font-weight: 700;
  margin-top: 8px;
  display: block;
}

.c-wallet-values-summary {
  min-height: 662px;
  max-width: 360px;
  margin: 0 auto;
  z-index: 29;

  @media (min-width: $desktop) {
    padding-top: 2.5em;
  }

  &__wrapper {
    padding: 1.5em 1em;
    background-color: $gray-1;
  }

  &__header {
    padding-bottom: 0.8em;
    text-align: center;
    border-bottom: 2px solid $gray-3;
    @media (min-width: $tablet) {
      border-width: 1px;
    }
  }

  &__footer {
    max-width: 320px;
    padding: 1em 0;
    margin: 0 auto;
    text-align: center;
  }

  &--fixed {
    top: 63px;
    @media (min-width: $mobile) {
      position: fixed !important;
      width: 256px;
    }
    @media (min-width: $desktop) {
      min-width: 342px;
    }
    @media (min-width: 1216px) {
      width: 384px;
    }
    @media (min-width: 1400px) {
      width: 448px;
    }
  }

  &--sticky {
    top: 63px;
    position: sticky;
    //overflow: hidden;
  }

  .tooltip {
    position: absolute;
  }

  .about-taxes {
    line-height: 1;
  }

  .c-base-card-color {
    padding: 0.5em;
    margin-bottom: 0em;
    margin-top: 0.5em;
    cursor: pointer;

    @media (min-width: $desktop) {
      padding: 0.8em;
    }

    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;

      @media (min-width: $desktop) {
        font-size: 16px;
      }
    }

    &__description {
      line-height: 1;
      max-width: 170px;
    }

    &__money {
      font-weight: bold;
      display: inline-flex;
      justify-content: flex-end;
      align-items: center;
      min-width: 106px;
    }

    &__arrow-button {
      background-color: transparent;
      display: inline-flex;
      color: #8493a2;
      line-height: 1;
      outline: none;
      padding: 0;
      height: 24px;
      border: 0;
      margin-left: 6px;
      align-items: center;
      cursor: pointer;

      .icon {
        height: 1rem;
        width: 1rem;
      }
    }
  }
}
.button-withdraw-pix {
  position: relative;

  &__tooltip {
    z-index: 30;
    height: 180px;
    text-align: left;
    position: absolute;
    top: -190px;

    @media (min-width: $tablet) {
      width: 400px;
      height: 170px;
      top: -61px;
      right: -410px;
    }
  }
}
</style>
